import { ROOT_SECTION } from 'shared-base';
import { version } from '../globals';

export namespace ideas {
  export const get = async (id: string) => {
    const root = ROOT_SECTION('browse-ideas');

    const data = await fetch(`${root}/browse-${id}.json?${version}`).then((res) => res.json());

    return {
      isSuccess: true,
      data: data,
    };
  };
}
